import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useTestimonials from "../../Utils/useTestimonials";
import { Col, Row, Container } from "react-bootstrap";
import "./TestimonialCarousel.css";
import parse from "html-react-parser";

const TestimonialCarousel = () => {

  const testimonialData = useTestimonials();

  const settings = {
    dots: false,
    infinite: true,
    speed: 3000,
    autoplaySpeed: 8000,
    slidesToShow: 1,
    swipe: true,
    swipeToSlide: true,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };


  return (
    <div className='testimonial-container'>
      <Container>
        <Row className="testimonial-row">
          <Col lg={6} md={6} sm={12} xs={12} xl={6} className="testimonial-col">
            {/* <Slider {...settings} id="about-carousel" > */}
            {testimonialData && testimonialData.map((item) => (
              <div key={item.id}>
                <div className='testimonial-name-section'>
                  {item.text !== "null" ? <h4 className='testimonial-text'>{parse(item.text)}</h4> : null}
                  <div className="img-name-section">
                    {/* {item.loImg !== "null" ? <img className='testimonial-lo-img' src={item.loImg}></img>: null} */}
                    <div>
                      {item.name !== "null" ? <p className='testimonial-name'>{parse(item.name)}<br></br>
                      {parse(item.loNMLS)}{' '} | {' '}{parse(item.companyName)}</p> : null}
                    </div>
                  </div>
                </div>
                {/* {item.imgMobile !== "null" ? <div><img className='testimonial-img' src={item.imgMobile}></img> <img className='testimonial-img-desktop' src={item.img}></img></div> : null} */}
              </div>
            ))}
            {/* </Slider> */}
          </Col>
          <Col lg={6} md={6} sm={12} xs={12} xl={6} className="testimonial-col">
            {testimonialData && testimonialData.map((item) => (
              <div key={item.id}>
                {item.imgMobile !== "null" ? <div><img className='testimonial-img' src={item.imgMobile}></img> <img className='testimonial-img-desktop' src={item.img}></img></div> : null}
              </div>
            ))}
          </Col>
        </Row>
      </Container>
    </div>

  )

}

export default TestimonialCarousel;